import React, { ReactElement } from 'react';
import { Message } from 'mage-i18n';
import { OnboardingGroup } from '@/bpc/components/OnboardingGroupComponent/OnboardingGroup';
import { AlertBlock } from '@klarna/bubble-ui';

const Strong = value => <strong>{value}</strong>;

export const makeSubtitleElement = (
  group: OnboardingGroup,
  t: TranslatorFunction,
): ReactElement | null => {
  const isMorOnboarding =
    group.payload?.contract_onboarding_type === 'MOR_ONBOARDING_GROUP' ||
    group.payload?.contract_onboarding_type === 'MOR_ONBOARDING_ENTITY';

  const translatedSubtitle = t(group.labelSubtitle);
  const isTranslationValid =
    translatedSubtitle &&
    translatedSubtitle !== group.labelSubtitle &&
    translatedSubtitle.trim() !== '';
  const content = isTranslationValid ? translatedSubtitle : group.fallbackSubtitle;

  if (isMorOnboarding) {
    return content;
  } else {
    return group.labelSubtitle ? (
      <Message path={group.labelSubtitle} params={{ strong: Strong }} />
    ) : null;
  }
};

export const getInfoBoxText = (
  group: OnboardingGroup,
  t: TranslatorFunction,
): ReactElement | null => {
  const infoText = group.labelTitle.replace('title', 'infobox');

  const translatedText = t(infoText);
  const isTranslationValid =
    translatedText && translatedText !== infoText && translatedText.trim() !== '';
  const content = isTranslationValid ? translatedText : group.description;

  const isDescriptionValid = group.description && group.description.length > 0;

  const splitContent = content
    .split('\n')
    .map((text, index) => <div key={index}>{text.trim()}</div>);

  return isDescriptionValid || isTranslationValid ? <AlertBlock content={[splitContent]} /> : null;
};
